import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const KhatavaniReport = ({ combinedData, schoolData, khateDetails,fyear, onClose }) => {
  const [studentFeeData, setStudentFeeData] = useState({});
  const [attachedCredit, setAttachedCredit] = useState('');
  const udiseNumber = localStorage.getItem("udiseNumber");
  
  const taluka = schoolData ? schoolData.taluka : "";
  const jilha = schoolData ? schoolData.jilha : "";
  const [language, setLanguage] = useState(localStorage.getItem("language") || "English");
  const printRef = useRef();

  // Function to get kirdWithFeeattach data from IndexedDB
  const getKirdWithFeeattachData = () => {
    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open('SchoolManagementDB', 1);
      openRequest.onerror = (event) => reject(event.target.error);
      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['kirdWithFeeattach'], 'readonly');
        const objectStore = transaction.objectStore('kirdWithFeeattach');
        const getRequest = objectStore.get(fyear);
        getRequest.onerror = (event) => reject(event.target.error);
        getRequest.onsuccess = (event) => resolve(event.target.result);
      };
    });
  };

  // Fetch student fee data
  useEffect(() => {
    const fetchStudentFeeData = async () => {
      try {
        const kirdData = await getKirdWithFeeattachData();
        if (kirdData && kirdData.typeofattach === "combinedPavati") {
          setAttachedCredit(kirdData.creditKhate);
          
          const response = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${fyear}.json`
          );
          const studentFees = await response.json();
          
          const feeGroups = {};
          const lastBeforePayMap = {};

          for (const serialNo in studentFees) {
            for (const invoiceNo in studentFees[serialNo]) {
              const feeData = studentFees[serialNo][invoiceNo];
              
              for (const feeType in feeData) {
                const feeDetails = feeData[feeType];
                const date = feeDetails.date;
                
                if (!feeGroups[date]) {
                  feeGroups[date] = {
                    totalPaid: 0,
                    invoiceNumbers: new Set(),
                    transactions: []
                  };
                }

                const previousTotal = lastBeforePayMap[`${serialNo}_${feeType}`] || 0;
                const currentBeforePay = parseFloat(feeDetails.beforePay) || 0;
                const paidAmount = currentBeforePay - previousTotal;

                if (paidAmount > 0) {
                  feeGroups[date].invoiceNumbers.add(invoiceNo);
                  feeGroups[date].totalPaid += parseFloat(paidAmount);
                  feeGroups[date].transactions.push({
                    invoiceNo,
                    feeType,
                    paidAmount: paidAmount.toFixed(2),
                    date,
                  });
                  lastBeforePayMap[`${serialNo}_${feeType}`] = currentBeforePay;
                }
              }
            }
          }

          setStudentFeeData(feeGroups);
        }
      } catch (error) {
        console.error("Error fetching student fee data:", error);
      }
    };

    fetchStudentFeeData();
  }, [udiseNumber, fyear]);

  const groupByKhate = () => {
    const groupedData = {};

    Object.keys(combinedData).forEach(pavtiNo => {
      const jamaEntries = combinedData[pavtiNo].jama || [];
      const naveEntries = combinedData[pavtiNo].nave || [];

      // Group Jama entries by khate (Credit entries)
      jamaEntries.forEach(jamaEntry => {
        const khate = jamaEntry.credit1 || 'Unknown';
        if (!groupedData[khate]) {
          groupedData[khate] = [];
        }

        groupedData[khate].push({
          khatePrakar: String(jamaEntry.khatePrakar),
          jama: String(jamaEntry.amount),
          nave: '', 
          date: String(jamaEntry.date),
          pavtiNo: String(jamaEntry.pavtiNo),
        });
      });

      // Group Nave entries by debit1 (Debit entries)
      naveEntries.forEach(naveEntry => {
        const khate = naveEntry.debit1 || 'Unknown';
        if (!groupedData[khate]) {
          groupedData[khate] = [];
        }

        groupedData[khate].push({
          khatePrakar: String(naveEntry.khatePrakar),
          jama: '',
          nave: String(naveEntry.amount),
          date: String(naveEntry.date),
          pavtiNo: String(naveEntry.pavtiNo),
        });
      });
    });

    return groupedData;
  };

  const groupedData = groupByKhate();

  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=1000');
    printWindow.document.write('<html><head><title>Ledger Report</title>');
    printWindow.document.write(`
      <style>
        body {
          font-family: Arial, sans-serif; 
          margin: 0;
          padding: 20px;
        }
        table {
          width: 100%; 
          max-width: 700px; 
          border-collapse: collapse; 
          margin: 10px auto;
        }
        th, td {
          border: 1px solid #000; 
          padding: 8px;
          text-align: center;
        }
        th {
          background-color: #8A1538;
          color: white;
        }
        tr:nth-child(even) {
          background-color: #f2f2f2; 
        }
        h1, h3 {
          text-align: center;
        }
        .school-info {
          background-color: #f0f0f0;
          padding: 20px;
          margin-bottom: 20px;
          text-align: center;
          border: 1px solid #000;
        }
        .header-title {
          background-color: #000;
          color: #fff;
          padding: 5px;
          display: block; 
          width: fit-content; 
          margin: 10px auto;
          border-radius: 10px;
        }
        .student-fee-row {
          background-color: #e6f7ff;
        }
        .student-fee-note {
          font-size: 0.8em;
          color: #666;
        }
        @media print {
          body {
            margin: 0; 
            padding: 0;
          }
          table {
            width: 680px !important;
            margin: auto;
          }
          .page-break {
            page-break-before: always; 
          }
        }
      </style>
    `);
    printWindow.document.write('</head><body>');
    printWindow.document.write(printRef.current.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div style={report1Overlay}>
      <div style={report1Container}>
        <button style={closeButtonStyle1} onClick={onClose}>Close</button>
        <button onClick={handlePrint} style={printButtonStyle1}>
          Print Report
        </button>

        <div ref={printRef} style={{ overflowY: 'auto', maxHeight: '70vh', width: '100%' }}>
          <div className="khatavani-report">
            {/* School Info Section */}
            <div style={schoolInfoStyle}>
              <h1 style={{ margin: "0", fontSize: "24px", fontWeight: "bold" }}>
                {schoolData.schoolName}
              </h1>
              <p style={{ margin: "5px 0", fontSize: "16px" }}>
                {language === "English" ? "Taluka: " : "तालुका: "} {taluka},
                {language === "English" ? " District: " : " जिल्हा: "} {jilha}
              </p>
              <p style={{ margin: "5px 0", fontSize: "16px" }}>
                {language === "English" ? "Email: " : "ई-मेल: "} {schoolData.email}, 
                {language === "English" ? "Mobile Number : " : "मोबाईल नंबर: "} {schoolData.mobileNumber}
              </p>
              <hr />
              <h6 style={headerTitleStyle}>
                {language === "English" ? "Ledger Report " : "खतावणी अहवाल "}
              </h6>
            </div>

            {Object.keys(groupedData).map((khate, index) => {
              const khateAmount = parseFloat(khateDetails.find(kh => kh.khate === khate)?.amount || 0);
              const khateEntries = groupedData[khate];
              const isStudentFeeAccount = khate === attachedCredit;

              let jamaTotal = 0;
              let naveTotal = 0;
              let bakiTotal = khateAmount > 0 ? khateAmount : 0;

              return (
                <div key={index} className="khate-section page-break" style={pageStyle}>
                  <h6 className="khate-title">Account: {khate}</h6>
                  <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                    <table className="khate-table mb-3" style={{ width: '700px', border: "1px solid black" }}>
                      <thead>
                        <tr>
                          <th style={tableHeaderStyle}>{language === "English" ? "Date " : "दिनांक "}</th>
                          <th style={tableHeaderStyle}>{language === "English" ? "Account details" : "खात्याचे तपशील "}</th>
                          <th style={tableHeaderStyle}>{language === "English" ? "Credit" : "जमा "}</th>
                          <th style={tableHeaderStyle}>{language === "English" ? "Debit" : "नावे "}</th>
                          <th style={tableHeaderStyle}>{language === "English" ? "Balance" : "बाकी"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={tableCellStyle}></td>
                          <td style={tableCellStyle}>Open Balance</td>
                          <td style={tableCellStyle}></td>
                          <td style={tableCellStyle}></td>
                          <td style={tableCellStyle}>{bakiTotal > 0 ? bakiTotal.toFixed(2) : ''}</td>
                        </tr>

                        {/* Add student fee entries for this account if it matches the attached credit */}
                        {isStudentFeeAccount && Object.entries(studentFeeData)
                          .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB))
                          .map(([date, feeData]) => {
                            const totalPaid = feeData.totalPaid;
                            if (totalPaid > 0) {
                              bakiTotal += totalPaid;
                              jamaTotal += totalPaid;
                              return (
                                <tr key={`student-fee-${date}`} className="student-fee-row">
                                  <td style={tableCellStyle}>
                                    {new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}
                                  </td>
                                  <td style={tableCellStyle}>
                                    {/* {attachedCredit} <br /> */}
                                    <span className="student-fee-note">
                                     Transferred from student fees <br />
                                      {/* (Invoice No: 
                                      {Array.from(feeData.invoiceNumbers).join(', ')}) */}
                                    </span>
                                  </td>
                                  <td style={tableCellStyle}>{totalPaid.toFixed(2)}</td>
                                  <td style={tableCellStyle}></td>
                                  <td style={tableCellStyle}>{bakiTotal.toFixed(2)}</td>
                                </tr>
                              );
                            }
                            return null;
                          })}

                        {khateEntries
                          .filter(entry => {
                            const entryDate = new Date(entry.date);
                            const month = entryDate.getMonth();
                            return month;
                          })
                          .sort((a, b) => new Date(a.date) - new Date(b.date))
                          .map((entry, i) => {
                            const jamaAmount = parseFloat(entry.jama || 0);
                            const naveAmount = parseFloat(entry.nave || 0);
                            jamaTotal += jamaAmount;
                            naveTotal += naveAmount;
                            bakiTotal += jamaAmount - naveAmount;

                            return (
                              <tr key={i}>
                                <td style={tableCellStyle}>
                                  {new Date(entry.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}
                                </td>
                                <td style={tableCellStyle}>{entry.khatePrakar}</td>
                                <td style={tableCellStyle}>{jamaAmount ? jamaAmount.toFixed(2) : ''}</td>
                                <td style={tableCellStyle}>{naveAmount ? naveAmount.toFixed(2) : ''}</td>
                                <td style={tableCellStyle}>{bakiTotal >= 0 ? bakiTotal.toFixed(2) : ''}</td>
                              </tr>
                            );
                          })}

                        {/* Closing Balance Row */}
                        <tr>
                          <td style={tableCellStyle}></td>
                          <td style={tableCellStyle}>Closing Balance</td>
                          <td style={tableCellStyle}>{bakiTotal >= 0 ? bakiTotal.toFixed(2) : `- ${Math.abs(bakiTotal).toFixed(2)}`}</td>
                          <td style={tableCellStyle}></td>
                          <td style={tableCellStyle}></td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td style={tableCellStyle} colSpan="2">Total</td>
                          <td style={tableCellStyle}>{jamaTotal.toFixed(2)}</td>
                          <td style={tableCellStyle}>{naveTotal.toFixed(2)}</td>
                          <td style={tableCellStyle}></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// Styles
const report1Overlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backdropFilter: 'blur(3px)',
  zIndex: 1000,
};

const report1Container = {
  background: 'white',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  maxWidth: '900px',
  width: '100%',
  position: 'relative',
  color: 'black',
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxHeight: '80vh',
};

const closeButtonStyle1 = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'transparent',
  border: 'none',
  fontSize: '20px',
  cursor: 'pointer',
  color: 'Red'
};

const printButtonStyle1 = {
  margin: '10px 0',
  padding: '10px 20px',
  backgroundColor: '#8A1538',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

const schoolInfoStyle = {
  backgroundColor: "#f0f0f0",
  padding: "20px",
  marginBottom: "20px",
  textAlign: "center",
  border: "1px solid #000",
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '90%',
};

const headerTitleStyle = {
  textAlign: "center",
  backgroundColor: "#000",
  color: "#fff",
  padding: "4px",
  display: "block",
  width: "fit-content",
  margin: "0 auto",
  borderRadius: "10px",
  marginBottom: "10px",
  fontSize: "20px",
};

const pageStyle = {
  width: '210mm',
  height: '297mm',
  border: '2px solid black',
  margin: '20px auto',
  padding: '10px',
  borderRadius: '5px',
  boxSizing: 'border-box',
};

const tableHeaderStyle = {
  backgroundColor: '#8A1538',
  textAlign: 'center',
  color: 'white',
  border: '1px solid black'
};

const tableCellStyle = {
  textAlign: 'center',
  border: '1px solid black'
};

export default KhatavaniReport;